import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: 'website' | 'article';
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  articlePublishedTime,
  articleModifiedTime,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, property?: string) => {
      if (property) {
        let el = document.querySelector(`meta[property="${property}"]`);
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute('property', property);
          document.head.appendChild(el);
        }
        el.setAttribute('content', content);
      } else {
        let el = document.querySelector(`meta[name="${name}"]`);
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute('name', name);
          document.head.appendChild(el);
        }
        el.setAttribute('content', content);
      }
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const link = document.querySelector('link[rel="canonical"]');
    if (link) link.setAttribute('href', canonicalUrl);

    setMeta('og:title', title, 'og:title');
    setMeta('og:description', description, 'og:description');
    setMeta('og:type', ogType, 'og:type');
    setMeta('og:url', canonicalUrl, 'og:url');
    setMeta('og:site_name', '打屁股漫画大全', 'og:site_name');
    setMeta('og:locale', 'zh_CN', 'og:locale');
    if (ogImage) {
      setMeta('og:image', ogImage, 'og:image');
      setMeta('og:image:width', '1200', 'og:image:width');
      setMeta('og:image:height', '630', 'og:image:height');
    }

    setMeta('twitter:card', 'summary_large_image', 'twitter:card');
    setMeta('twitter:title', title, 'twitter:title');
    setMeta('twitter:description', description, 'twitter:description');
    if (ogImage) setMeta('twitter:image', ogImage, 'twitter:image');

    if (articlePublishedTime) {
      setMeta('article:published_time', articlePublishedTime, 'article:published_time');
    }
    if (articleModifiedTime) {
      setMeta('article:modified_time', articleModifiedTime, 'article:modified_time');
    }

    return () => {
      document.title = '打屁股漫画大全 · 经典惩罚场景合集';
    };
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, articlePublishedTime, articleModifiedTime]);

  return null;
}